<ham-modal
    [title]="
        view === 'confirm_disconnect'
            ? ('aumico_integration_sharepoint_manage_disconnect_confirm_title' | i18next)
            : ('aumico_integration_sharepoint_manage_modal_title' | i18next)
    "
    [hideFooter]="true"
    [size]="'md'"
    (cancel)="onClose()"
>
    <div
        class="sharepoint-manage-body"
        *ngIf="connections$ | async as connections"
        [class.sharepoint-manage-body--confirm]="view === 'confirm_disconnect'"
    >
      <!-- ─────────── Connection list ─────────── -->
      <ng-container *ngIf="view === 'list'">
        <!-- Nothing connected: only reachable if the last connection was just removed,
             since the card routes an unconnected vendor straight to the connect modal. -->
        <p *ngIf="connections.length === 0" class="sharepoint-manage-body__empty">
            {{ 'aumico_integration_sharepoint_manage_empty' | i18next }}
        </p>

        <ul class="sharepoint-manage-body__list" *ngIf="connections.length > 0">
            <li
                *ngFor="let connection of connections; trackBy: trackByConnection"
                class="sharepoint-manage-body__row"
                [class.sharepoint-manage-body__row--highlighted]="
                    connection.id === initialConnectionId
                "
            >
                <div class="sharepoint-manage-body__row-main">
                    <span class="sharepoint-manage-body__name">{{ connection.displayName }}</span>

                    <!-- Same two-word badge vocabulary as the card, so the modal and the
                         card cannot describe one connection differently. There is no
                         per-ConnectionStatus i18n key set to build a key from. -->
                    <span
                        *ngIf="connection.status === ConnectionStatus.CONNECTED"
                        class="sharepoint-manage-body__badge sharepoint-manage-body__badge--ok"
                    >
                        {{ 'aumico_integration_card_status_connected' | i18next }}
                    </span>
                    <span
                        *ngIf="
                            connection.status === ConnectionStatus.EXPIRED ||
                            connection.status === ConnectionStatus.ERROR
                        "
                        class="sharepoint-manage-body__badge sharepoint-manage-body__badge--warn"
                    >
                        {{ 'aumico_integration_card_status_action_required' | i18next }}
                    </span>
                </div>

                <small class="sharepoint-manage-body__meta">
                    {{ 'aumico_integration_sharepoint_manage_connected_at' | i18next }}
                    {{ connection.connectedAt | dateLocale }}
                </small>

                <!-- Surface the reason so an admin can act on an unhealthy connection. -->
                <small
                    *ngIf="connection.lastErrorMessage != null"
                    class="sharepoint-manage-body__error"
                >
                    {{ connection.lastErrorMessage }}
                </small>

                <ham-button
                    variant="primary"
                    size="sm"
                    [outline]="true"
                    (buttonClick)="onRequestDisconnect(connection)"
                >
                    {{ 'aumico_integration_sharepoint_manage_disconnect_button' | i18next }}
                </ham-button>
            </li>
        </ul>

        <div class="sharepoint-manage-body__actions">
            <ham-button variant="primary" size="sm" (buttonClick)="onAddConnection()">
                {{ 'aumico_integration_sharepoint_manage_add_button' | i18next }}
            </ham-button>
            <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onClose()">
                {{ 'aumico_button_close' | i18next }}
            </ham-button>
        </div>
      </ng-container>

      <!-- ─────────── Disconnect confirm (destructive, no undo) ─────────── -->
      <ng-container *ngIf="view === 'confirm_disconnect' && disconnectCandidate as candidate">
        <div class="sharepoint-manage-body__centered">
            <div class="sharepoint-manage-body__warn-icon">!</div>
            <h3 class="sharepoint-manage-body__heading">
                {{ 'aumico_integration_sharepoint_manage_disconnect_confirm_title' | i18next }}
            </h3>
            <p class="sharepoint-manage-body__name">{{ candidate.displayName }}</p>
            <p class="sharepoint-manage-body__meta">
                {{ 'aumico_integration_sharepoint_manage_disconnect_confirm_text' | i18next }}
            </p>

            <div class="sharepoint-manage-body__actions">
                <ham-button variant="red" size="sm" (buttonClick)="onConfirmDisconnect()">
                    {{ 'aumico_integration_sharepoint_manage_disconnect_button' | i18next }}
                </ham-button>
                <ham-button
                    variant="primary"
                    size="sm"
                    [outline]="true"
                    (buttonClick)="onCancelDisconnect()"
                >
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </div>
      </ng-container>
    </div>
</ham-modal>
